// extracted by mini-css-extract-plugin
module.exports = {"tokensInfo":"styles_tokensInfo__1YapV","title":"styles_title__12v0R","tokensList":"styles_tokensList__hFc0w","tokenImage":"styles_tokenImage__3PBUG"};